/* POSTIFULL - Teslimat adresi adimi (sepet -> odeme) · 2026-10-20
   "Odeme Yap" (sepet cekmecesi + sepet sayfasi) tiklaninca once bu pencere acilir:
   Ad, Soyad, Telefon, E-posta + Il / Ilce / Mahalle (listeden, zorunlu) + Acik adres.
   Onaylaninca: sepet ozelliklerine adres yazilir (siparis ayrintilarinda gorunur) ve musteri
   /checkout?checkout[...] ile odeme sayfasina adres DOLU olarak gider.
   Veri: assets/pf-adres-iller.json -> { iller: [{p:"55", k:"TR-55", ad:"Samsun", f:"<il verisi dosyasi>", kg?}] }
         <f> -> { "55": { ilceler: [{ ad:"Atakum", kg?, m: [["Alanlı Mah.", "55200", kgId?], ...] }] } }
   Yapilandirma: window.PFAdres = { base: asset_url(pf-adres-iller.json), css: asset_url(pf-adres.css), musteri: {...}|null }
   Not: Shopify planinda odeme sayfasina kod eklenemiyor; musteri odeme sayfasinda adresi yine degistirebilir. */
(function () {
  'use strict';
  if (window.__pfAdres) return;
  window.__pfAdres = true;

  var CFG = window.PFAdres || {};
  var LS = 'pf-adres-v1';
  var coll = window.Intl && Intl.Collator ? new Intl.Collator('tr') : null;
  var index = null, files = {}, root = null, busy = false;

  function assetUrl(name) {
    var b = String(CFG.base || '');
    return b.replace(/pf-adres-iller\.json(\?.*)?$/, name);
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function loadIndex() {
    return index ? Promise.resolve(index) : getJSON(CFG.base).then(function (d) { index = d; return d; });
  }
  function loadIl(il) {
    if (!il || !il.f) return Promise.reject(new Error('il'));
    var f = il.f;
    files[f] = files[f] || getJSON(assetUrl(f)).catch(function (e) { delete files[f]; throw e; });
    return files[f].then(function (d) { return d[il.p] || { ilceler: [] }; });
  }
  function store(v) { try { if (v) localStorage.setItem(LS, JSON.stringify(v)); return JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function trUpper(s) { return String(s || '').replace(/i/g, 'İ').replace(/ı/g, 'I').toUpperCase(); }

  function loadCss() {
    if (!CFG.css || document.querySelector('link[data-pf-adres]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CFG.css; l.setAttribute('data-pf-adres', '');
    document.head.appendChild(l);
  }

  var IC_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var IC_LOCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var IC_PIN = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11Z"/><circle cx="12" cy="10" r="2.5"/></svg>';

  function field(id, label, html, cls) {
    return '<div class="pfa-f' + (cls ? ' ' + cls : '') + '" data-f="' + id + '"><label for="pfa-' + id + '">' + label + '</label>' + html + '<p class="pfa-err" data-err="' + id + '"></p></div>';
  }

  function build() {
    loadCss();
    root = document.createElement('div');
    root.className = 'pfa-ov';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'pfa-title');
    root.innerHTML =
      '<form class="pfa-box" novalidate autocomplete="on">' +
        '<div class="pfa-head"><div><p class="pfa-eye">' + IC_LOCK + 'Güvenli ödeme · 1 / 2</p><h2 id="pfa-title" class="pfa-title">Teslimat bilgileri</h2></div>' +
        '<button type="button" class="pfa-x" aria-label="Kapat">' + IC_X + '</button></div>' +
        '<div class="pfa-body">' +
          '<p class="pfa-sec">İletişim</p>' +
          '<div class="pfa-row">' +
            field('ad', 'Ad', '<input id="pfa-ad" name="given-name" autocomplete="given-name" maxlength="60">') +
            field('soyad', 'Soyad', '<input id="pfa-soyad" name="family-name" autocomplete="family-name" maxlength="60">') +
          '</div>' +
          field('tel', 'Cep telefonu', '<div class="pfa-tel"><span>+90</span><input id="pfa-tel" name="tel" type="tel" inputmode="tel" autocomplete="tel-national" placeholder="5XX XXX XX XX" maxlength="16"></div>') +
          field('eposta', 'E-posta', '<input id="pfa-eposta" name="email" type="email" inputmode="email" autocomplete="email" maxlength="120" placeholder="ornek@mail.com">') +
          '<p class="pfa-sec">' + IC_PIN + 'Teslimat adresi</p>' +
          '<p class="pfa-hint">Kargonuzun sorunsuz ulaşması için il, ilçe ve mahalleyi listeden seçin.</p>' +
          field('il', 'İl', '<select id="pfa-il" autocomplete="off"><option value="">Yükleniyor…</option></select>') +
          '<div class="pfa-row pfa-row--adr">' +
            field('ilce', 'İlçe', '<select id="pfa-ilce" disabled autocomplete="off"><option value="">Önce il seçin</option></select>') +
            field('mah', 'Mahalle', '<select id="pfa-mah" disabled autocomplete="off"><option value="">Önce ilçe seçin</option></select>') +
          '</div>' +
          field('acik', 'Açık adres', '<textarea id="pfa-acik" name="street-address" autocomplete="street-address" rows="2" maxlength="200" placeholder="Cadde / sokak, bina no, kat, daire"></textarea>') +
          '<p class="pfa-pk" data-pk></p>' +
        '</div>' +
        '<div class="pfa-foot">' +
          '<button type="submit" class="pfa-go"><span>Ödemeye geç</span><svg width="18" height="10" viewBox="0 0 18 10" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M0 5h16M12 1l4 4-4 4"/></svg></button>' +
          '<p class="pfa-note">Bilgileriniz ödeme sayfasına otomatik aktarılır.</p>' +
        '</div>' +
      '</form>';
    document.body.appendChild(root);
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    root.querySelector('.pfa-x').addEventListener('click', close);
    root.querySelector('form').addEventListener('submit', submit);
    var $ = function (id) { return root.querySelector('#pfa-' + id); };
    $('il').addEventListener('change', function () { onIl(this.value); });
    $('ilce').addEventListener('change', function () { onIlce(this.value); });
    $('mah').addEventListener('change', function () { showPk(); clearErr('mah'); });
    ['ad', 'soyad', 'tel', 'eposta', 'acik'].forEach(function (k) { $(k).addEventListener('input', function () { clearErr(k); }); });
    $('tel').addEventListener('blur', function () { var t = normTel(this.value); if (t) this.value = fmtTel(t); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  }

  var ilData = null, cur = { il: null, ilce: null };
  function $(id) { return root.querySelector('#pfa-' + id); }
  function opts(sel, list, ph, val) {
    sel.innerHTML = '<option value="">' + ph + '</option>' + list.map(function (o) { return '<option value="' + esc(o.v) + '"' + (o.v === val ? ' selected' : '') + '>' + esc(o.t) + '</option>'; }).join('');
  }

  function onIl(p, keep) {
    clearErr('il');
    var il = index && index.iller.filter(function (x) { return x.p === p; })[0];
    cur.il = il || null; cur.ilce = null; ilData = null;
    var ilce = $('ilce'), mah = $('mah');
    opts(mah, [], 'Önce ilçe seçin'); mah.disabled = true; showPk();
    if (!il) { opts(ilce, [], 'Önce il seçin'); ilce.disabled = true; return Promise.resolve(); }
    opts(ilce, [], 'Yükleniyor…'); ilce.disabled = true;
    return loadIl(il).then(function (d) {
      if (cur.il !== il) return;
      ilData = d;
      opts(ilce, d.ilceler.map(function (x) { return { v: x.ad, t: x.ad }; }), 'İlçe seçin', keep && keep.ilce);
      ilce.disabled = false;
      if (keep && keep.ilce) return onIlce(keep.ilce, keep);
    }).catch(function () { opts(ilce, [], 'Liste yüklenemedi, tekrar deneyin'); ilce.disabled = false; });
  }
  function onIlce(ad, keep) {
    clearErr('ilce');
    var mah = $('mah');
    var x = ilData && ilData.ilceler.filter(function (i) { return i.ad === ad; })[0];
    cur.ilce = x || null;
    if (!x) { opts(mah, [], 'Önce ilçe seçin'); mah.disabled = true; showPk(); return; }
    opts(mah, x.m.map(function (m) { return { v: m[0], t: m[0] }; }), 'Mahalle seçin (' + x.m.length + ')', keep && keep.mah);
    mah.disabled = false;
    showPk();
  }
  function mahRow() {
    var v = $('mah').value;
    return cur.ilce && v ? cur.ilce.m.filter(function (m) { return m[0] === v; })[0] : null;
  }
  function showPk() {
    var m = mahRow(), el = root.querySelector('[data-pk]');
    el.textContent = m && m[1] ? 'Posta kodu: ' + m[1] : '';
  }

  function normTel(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('90') === 0) d = d.slice(2);
    if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    return /^5\d{9}$/.test(d) ? d : '';
  }
  function fmtTel(d) { return d.slice(0, 3) + ' ' + d.slice(3, 6) + ' ' + d.slice(6, 8) + ' ' + d.slice(8); }
  function setErr(k, msg) {
    var f = root.querySelector('[data-f="' + k + '"]'); if (f) f.classList.add('is-err');
    var e = root.querySelector('[data-err="' + k + '"]'); if (e) e.textContent = msg;
  }
  function clearErr(k) {
    var f = root.querySelector('[data-f="' + k + '"]'); if (f) f.classList.remove('is-err');
    var e = root.querySelector('[data-err="' + k + '"]'); if (e) e.textContent = '';
  }

  function fill() {
    var s = store() || {}, mu = CFG.musteri || {};
    $('ad').value = s.ad || mu.ad || '';
    $('soyad').value = s.soyad || mu.soyad || '';
    var t = normTel(s.tel || mu.tel || '');
    $('tel').value = t ? fmtTel(t) : '';
    $('eposta').value = s.eposta || mu.eposta || '';
    $('acik').value = s.acik || '';
    return loadIndex().then(function (d) {
      opts($('il'), d.iller.map(function (i) { return { v: i.p, t: i.ad }; }), 'İl seçin', s.p);
      if (s.p) return onIl(s.p, { ilce: s.ilce, mah: s.mah });
    }).catch(function () { opts($('il'), [], 'Liste yüklenemedi'); });
  }

  function open(fallback) {
    if (!root) build();
    ['ad', 'soyad', 'tel', 'eposta', 'il', 'ilce', 'mah', 'acik'].forEach(clearErr);
    root.style.display = 'flex';
    document.documentElement.classList.add('pfa-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    fill();
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('pfa-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.style.display = 'none'; }, 250);
  }

  function submit(e) {
    e.preventDefault();
    if (busy) return;
    var v = {
      ad: $('ad').value.trim(), soyad: $('soyad').value.trim(), tel: normTel($('tel').value),
      eposta: $('eposta').value.trim(), acik: $('acik').value.replace(/\s+/g, ' ').trim(),
      p: cur.il && cur.il.p, ilce: cur.ilce && cur.ilce.ad, mah: $('mah').value
    };
    var bad = [];
    if (v.ad.length < 2) bad.push(['ad', 'Adınızı yazın.']);
    if (v.soyad.length < 2) bad.push(['soyad', 'Soyadınızı yazın.']);
    if (!v.tel) bad.push(['tel', '5 ile başlayan 10 haneli cep telefonu numaranızı yazın.']);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.eposta)) bad.push(['eposta', 'Geçerli bir e-posta adresi yazın.']);
    if (!v.p) bad.push(['il', 'İl seçin.']);
    if (!v.ilce) bad.push(['ilce', 'İlçe seçin.']);
    if (!v.mah) bad.push(['mah', 'Mahalle seçin.']);
    if (v.acik.length < 10) bad.push(['acik', 'Cadde / sokak, bina no ve daire bilgisini yazın.']);
    else if (!/\d/.test(v.acik)) bad.push(['acik', 'Bina veya kapı numarasını ekleyin.']);
    if (bad.length) {
      bad.forEach(function (b) { setErr(b[0], b[1]); });
      var first = root.querySelector('[data-f="' + bad[0][0] + '"]');
      if (first) { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); var inp = first.querySelector('input,select,textarea'); if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 250); }
      return;
    }
    store(v);
    var m = mahRow() || [v.mah, ''];
    var il = cur.il;
    busy = true;
    var btn = root.querySelector('.pfa-go'); btn.setAttribute('aria-busy', 'true'); btn.querySelector('span').textContent = 'Ödeme sayfası açılıyor…';
    var attrs = {
      'Teslimat İl': il.ad, 'Teslimat İlçe': v.ilce, 'Teslimat Mahalle': v.mah, 'Teslimat Posta Kodu': m[1] || '',
      '_adres_kaynak': (index && index.kaynak ? String(index.kaynak).slice(0, 60) : '')
    };
    if (il.kg != null) attrs['_kg_il_id'] = String(il.kg);
    if (cur.ilce && cur.ilce.kg != null) attrs['_kg_ilce_id'] = String(cur.ilce.kg);
    if (m[2] != null) attrs['_kg_mahalle_id'] = String(m[2]);
    var q = new URLSearchParams();
    q.set('checkout[email]', v.eposta);
    q.set('checkout[shipping_address][first_name]', v.ad);
    q.set('checkout[shipping_address][last_name]', v.soyad);
    q.set('checkout[shipping_address][address1]', (v.mah + ', ' + v.acik).slice(0, 255));
    q.set('checkout[shipping_address][address2]', '');
    q.set('checkout[shipping_address][city]', v.ilce);
    q.set('checkout[shipping_address][province]', il.k);
    q.set('checkout[shipping_address][zip]', m[1] || '');
    q.set('checkout[shipping_address][country]', 'TR');
    q.set('checkout[shipping_address][phone]', '+90' + v.tel);
    var go = function () { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'checkout?' + q.toString(); };
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs })
    }).then(go, go);
    setTimeout(function () { busy = false; btn.removeAttribute('aria-busy'); btn.querySelector('span').textContent = 'Ödemeye geç'; }, 8000);
  }

  // --- odeme butonlarini yakala (sepet cekmecesi + sepet sayfasi + /checkout linkleri) ---
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.closest && f.closest('.pfa-ov')) return;
    var s = e.submitter;
    var isCheckout = (s && s.name === 'checkout') || (!s && f.querySelector('[name="checkout"]') && /\/cart\/?$/.test(f.getAttribute('action') || ''));
    if (!isCheckout) return;
    if (!CFG.base) return;
    e.preventDefault();
    e.stopPropagation();
    open(f);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !CFG.base) return;
    var h = a.getAttribute('href') || '';
    if (!/^(https?:\/\/[^/]*postifull[^/]*)?\/checkout\/?(\?.*)?$/.test(h)) return;
    e.preventDefault();
    open(null);
  }, true);

  window.PFAdres.open = open;
})();
